import type { MediumProps } from "@op/puck-types";
import { MediaPreview, useContent, useRender } from "@op/utils";
import { Dc_Media_Image } from "@op/sf-op";
import { MediumFigure } from "./MediumFigure";
import { MediumNonFigure } from "./MediumNonFigure";
// @ts-ignore
import placeholderImage from "../../../../../assets/placeholder.svg?url&no-inline";

const Medium = ({ medium, cover, noContainer }: MediumProps) => {
  const { meta } = useContent();
  const { context } = useRender();

  if (!medium) {
    if (context === "renderer") return null;
    return (
      <MediaPreview
        cover={cover}
        mimeType="image/svg+xml"
        src={placeholderImage}
        width={600}
        height={600}
      />
    );
  }
  return (
    <div
      style={{
        display: "contents",
        breakInside: "avoid-page",
      }}
    >
      {cover ? (
        <>
          {medium.metadata?.isFigure ? (
            <MediumFigure cover={cover} medium={medium} />
          ) : (
            <MediumNonFigure cover={cover} medium={medium} />
          )}
        </>
      ) : (
        <Dc_Media_Image
          noContainer={
            noContainer === true || meta.readingSettings.noContainer === true
          }
        >
          {medium.metadata?.isFigure ? (
            <MediumFigure cover={cover} medium={medium} />
          ) : (
            <MediumNonFigure cover={cover} medium={medium} />
          )}
        </Dc_Media_Image>
      )}
    </div>
  );
};

export default Medium;
